export const SHOW_INACTIVE_FORM_LABEL = "Show Inactive";
export const ONLY_SHOW_INACTIVE_FORM_LABEL = "Only Show Inactive";
export const ADVANCED_FILTERS_BUTTON_LABEL = "Advanced Filters";

export const SEARCH_BAR_LABEL = "Search Teacher";
export const TOGGLE_COACHES = "Show / Hide Teachers";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/advanced-filters/constants.ts